import {
  init,
  reactErrorHandler,
  reactRouterV7BrowserTracingIntegration,
  wrapCreateBrowserRouterV7,
} from "@sentry/react";
import { useEffect } from "react";
import {
  createBrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router";

import { DEPLOY_ENV, SENTRY_DSN } from "./env";

init({
  dsn: SENTRY_DSN,
  enabled: import.meta.env.PROD,
  environment: DEPLOY_ENV,
  integrations: [
    reactRouterV7BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  tracesSampleRate: 1.0,
});

export const wrappedCreateBrowserRouter =
  wrapCreateBrowserRouterV7(createBrowserRouter);

export const handleReactError = reactErrorHandler();
